import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConceptModel } from './concept.model';
import { ConceptFamilyModel } from '../conceptfamily/conceptfamily.model';
import { ConceptFamilyService } from '../conceptfamily/conceptfamily.service';
import { ConceptService } from './concept.service';
import { AccountsAndTaxesModel } from '../../invoice/preinvoice/accountsandtaxes.model';
import { PreinvoiceService } from '../../invoice/preinvoice/preinvoice.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DummyComponent } from '../../../shared/dummy.component';

@Component({
    selector: 'convfact-concept',
    templateUrl: './concept.component.html',
    styleUrls: ['./concept.component.css'],
    standalone: false
})
export class ConceptComponent implements OnInit {
  public concept = new ConceptModel();
  public errors = {};
  public families: ConceptFamilyModel[] = [];
  public accountsAndTaxes = new AccountsAndTaxesModel();
  public empty: boolean;

  public submit(): void {}

  constructor(
    private conceptService: ConceptService,
    private conceptFamilyService: ConceptFamilyService,
    private preinvoiceService: PreinvoiceService,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private router: Router,
    public dummy: DummyComponent
  ) {}

  public saveData(concept): void {
    if (concept.uid == null) {
      this.conceptService.addData(concept)
        .then(conceptResult => {
          this.concept = conceptResult;
          this.dummy.redirectTo(this.router.url);
        })
        .catch(errors => this.displayInfo(errors.error['message']));
    } else {
      this.conceptService.editData(concept.uid, concept)
        .then(conceptResult => {
          this.concept = conceptResult;
          this.dummy.redirectTo(this.router.url);
        })
        .catch(errors => this.displayInfo(errors.error['message']));
    }
  }

  ngOnInit(): void {
    this.preinvoiceService.accountsAndTaxesData().then(accountsAndTaxes => {
      this.accountsAndTaxes = accountsAndTaxes;
    });

    this.route.params.subscribe(params => {
      const uid = params['uid'];
      if (uid != undefined && uid.length === 36) {
        this.conceptService.loadData(uid).then(concept => this.concept = concept);
      }
    });

    this.conceptFamilyService.getList().then(families => {
      this.families = families;
      this.empty = this.families.length === 0;
    });
  }

  returnToIndex(): void {
    this.router.navigate(['/concept/edit']);
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }
}